<template>
<!-- 课程调研问卷 -->
    <div class="survey-main" v-if="body_show">
        <div class="form_grouping">
            <!-- 相符度 -->
            <div class="style_tags">
                <h2>{{title_list[0]}}</h2>
                <div class="style_tags_box radio-box clearfix">
                    <van-radio-group v-model="survey_list.consistent">
                        <van-radio :class="{'last-checkbox':consistent_group.length-1==index}"  v-for="(item,index) in consistent_group" :key="index" :name="item">{{item}}</van-radio>
                        <van-field :disabled="survey_list.consistent.indexOf('其他')<0"  class="survey-other pull-right clearfix"  v-model="consistent_name"   />
                    </van-radio-group>
                </div>
            </div>
            <!-- 项目整体体验满意度 -->
            <div  class="style_tags survey-mt">
                <h2>{{title_list[1]}}<span>（从0-10，分数越高，满意度越高）</span></h2>
                <van-cell-group class="style_tags grouping">
                    <van-field placeholder="请选择你对项目整体体验的满意度"  v-model="survey_list.experience"  @click="pickerType('experience')" readonly />
                    <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
                </van-cell-group>
            </div>
            <!-- 项目整体体验满意度 -->
            <div  class="style_tags survey-mt">
                <h2>{{title_list[2]}}</h2>
                <van-rate v-model="survey_list.input" :size="25" :count="10" color="#f44" void-icon="star" void-color="#d9d9d9" />
            </div>
            <!-- 你对【课程内容】的满意程度 -->
            <div  class="style_tags survey-mt">
                <h2>{{title_list[3]}}<span>（从0-10，分数越高，越满意，内容包括课程、任务攻略、大神导师团、自查清单、项目说明等）</span></h2>
                <van-cell-group class="style_tags grouping">
                    <van-field placeholder="请选择你对【课程内容】的满意程度"  v-model="survey_list.course_content"  @click="pickerType('course_content')" readonly />
                    <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
                </van-cell-group>
            </div>
            <!-- 你对【项目任务】设置的整体满意程度  -->
            <div  class="style_tags survey-mt">
                <h2>{{title_list[4]}}<span>（从0-10，分数越高，越满意，可以理解为每个项目里需要完成的作业部分。）</span></h2>
                <van-cell-group class="style_tags grouping">
                    <van-field placeholder="请选择你对【项目任务】设置的整体满意程度"  v-model="survey_list.project_tasks"  @click="pickerType('project_tasks')" readonly />
                    <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
                </van-cell-group>
            </div>
            <!-- 你对【运营支持】的整体满意程度  -->
            <div  class="style_tags survey-mt">
                <h2>{{title_list[5]}}<span>（从0-10，分数越高，越满意，包括对项目期间整体的运营服务、助教教练支持、运营流程方面的评价。）</span></h2>
                <van-cell-group class="style_tags grouping">
                    <van-field placeholder="请选择你对【运营支持】的整体满意程度"  v-model="survey_list.operating"  @click="pickerType('operating')" readonly />
                    <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
                </van-cell-group>
            </div>
            <!-- 你觉得最有收获的项目是？ -->
            <div class="style_tags survey-mt">
                <h2>{{title_list[6]}}</h2>
                <div class="style_tags_box radio-box clearfix">
                    <van-radio-group v-model="survey_list.harvest">
                        <van-radio   v-for="(item,index) in harvest_group" :key="index" :name="item">{{item}}</van-radio>
                    </van-radio-group>
                </div>
            </div>
            <!-- 你觉得收获不大的项目是？ -->
            <div class="style_tags survey-mt">
                <h2>{{title_list[7]}}</h2>
                <div class="style_tags_box radio-box clearfix">
                    <van-radio-group v-model="survey_list.no_harvest">
                        <van-radio   v-for="(item,index) in harvest_group" :key="index" :name="item">{{item}}</van-radio>
                    </van-radio-group>
                </div>
            </div>
            <!-- 对你完成项目最有帮助的环节是 -->
            <div class="style_tags survey-mt">
                <h2>{{title_list[8]}}</h2>
                <div class="style_tags_box clearfix">
                    <van-checkbox-group v-model="survey_list.help_link">
                        <van-checkbox :class="{'last-checkbox':help_link_group.length-1==index}"  v-for="(item,index) in help_link_group" :key="index"   :name="item">{{item}}</van-checkbox>
                        <van-field :disabled="survey_list.help_link.indexOf('其他')<0"  class="survey-other pull-right clearfix"  v-model="help_link_name"   />
                    </van-checkbox-group>
                </div>
            </div>
            <!-- 对你完成项目帮助不大的环节是 -->
            <div class="style_tags survey-mt">
                <h2>{{title_list[9]}}</h2>
                <div class="style_tags_box clearfix">
                    <van-checkbox-group v-model="survey_list.no_help_link">
                        <van-checkbox :class="{'last-checkbox':help_link_group.length-1==index}"  v-for="(item,index) in help_link_group" :key="index"   :name="item">{{item}}</van-checkbox>
                        <van-field :disabled="survey_list.no_help_link.indexOf('其他')<0"  class="survey-other pull-right clearfix"  v-model="no_help_link_name"   />
                    </van-checkbox-group>
                </div>
            </div>
            <!-- 学习过程中，你遇到的问题是？ -->
            <div class="style_tags survey-mt">
                <h2>{{title_list[10]}}</h2>
                <div class="style_tags_box clearfix">
                    <van-checkbox-group v-model="survey_list.problem">
                        <van-checkbox :class="{'last-checkbox':problem_group.length-1==index}"  v-for="(item,index) in problem_group" :key="index"   :name="item">{{item}}</van-checkbox>
                        <van-field :disabled="survey_list.problem.indexOf('其他')<0"  class="survey-other pull-right clearfix"  v-model="problem_name"   />
                    </van-checkbox-group>
                </div>
            </div>
            <!-- 你在本次项目学习中最重要的三点收获？ -->
            <div class="style_tags survey-mt">
                <h2>{{title_list[11]}}</h2>
                <div class="style_tags_box clearfix">
                    <van-cell-group class="grouping textarea">
                        <van-field type="textarea" placeholder="请填写你在本次项目学习中最重要的三点收获"  v-model="survey_list.project_harvest"   />
                    </van-cell-group>
                </div>
            </div>
            <!-- 你对项目还有哪些意见与建议？希望如何改进？ -->
            <div class="style_tags survey-mt">
                <h2>{{title_list[12]}}</h2>
                <div class="style_tags_box clearfix">
                    <van-cell-group class="grouping textarea">
                        <van-field type="textarea" placeholder="请填写你对项目的意见、建议与改进"  v-model="survey_list.advice"   />
                    </van-cell-group>
                </div>
            </div>
            <!-- 在项目过程中，你对【助教】提供支持的满意程度  -->
            <div  class="style_tags survey-mt">
                <h2>{{title_list[13]}}<span>（从0-10，分数越高，越满意，请以PBL学习方式的前提下，助教对小组和项目的支持程度打分，不涉及个性问题的解决）</span></h2>
                <van-cell-group class="style_tags grouping">
                    <van-field placeholder="请选择你对【助教】提供支持的满意程度"  v-model="survey_list.ta"  @click="pickerType('ta')" readonly />
                    <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
                </van-cell-group>
            </div>
            <!-- 你对你的助教有什么想说的？建议、意见或者纯表白 -->
            <div class="style_tags survey-mt">
                <h2>{{title_list[14]}}</h2>
                <div class="style_tags_box clearfix">
                    <van-cell-group class="grouping textarea">
                        <van-field type="textarea" placeholder="请填写你对你的助教有什么想说的？建议、意见或者纯表白"  v-model="survey_list.ta_advice"   />
                    </van-cell-group>
                </div>
            </div>
            <!-- 整体项目期间，你有没有给身边人介绍个人战略课？ -->
            <div class="style_tags survey-mt">
                <h2>{{title_list[15]}}<span>（包括项目介绍本身，你的项目成果，你的收获分享等等）</span></h2>
                <div class="style_tags_box radio-box clearfix">
                    <van-radio-group v-model="survey_list.introduce">
                        <van-radio :class="{'last-checkbox':introduce_group.length-1==index}"  v-for="(item,index) in introduce_group" :key="index" :name="item">{{item}}</van-radio>
                        <van-field :disabled="survey_list.introduce.indexOf('其他')<0"  class="survey-other pull-right clearfix"  v-model="introduce_name"   />
                    </van-radio-group>
                </div>
            </div>
            <!-- 如果有，你是如何介绍这个项目的？ -->
            <div v-show="survey_list.introduce==='有'" class="style_tags survey-mt">
                <h2>{{title_list[16]}}</h2>
                <div class="style_tags_box clearfix">
                    <van-cell-group class="grouping textarea">
                        <van-field type="textarea" placeholder="请填写如果有，你是如何介绍这个项目的？"  v-model="survey_list.introduce_successful"   />
                    </van-cell-group>
                </div>
            </div>
            <!--如果没有，原因是什么？-->
            <div v-show="survey_list.introduce==='没有'" class="style_tags survey-mt">
                <h2>{{title_list[17]}}</h2>
                <div class="style_tags_box clearfix">
                    <van-cell-group class="grouping textarea">
                        <van-field type="textarea" placeholder="请填写如果没有，原因是什么？"  v-model="survey_list.introduce_failure"   />
                    </van-cell-group>
                </div>
            </div>
            <!-- 请将你对自己分享项目的意愿度打分：  -->
            <div  class="style_tags survey-mt">
                <h2>{{title_list[18]}}<span>（从0-10，分数越高，意愿度越高）</span></h2>
                <van-cell-group class="style_tags grouping">
                    <van-field placeholder="请选择你对自己分享项目的意愿度分数"  v-model="survey_list.intend_to"  @click="pickerType('intend_to')" readonly />
                    <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
                </van-cell-group>
            </div>
            <!--为什么愿意分享？or为什么不愿意分享？-->
            <div  class="style_tags survey-mt">
                <h2>{{title_list[19]}}</h2>
                <div class="style_tags_box clearfix">
                    <van-cell-group class="grouping textarea">
                        <van-field type="textarea" placeholder="为什么愿意分享？or为什么不愿意分享？"  v-model="survey_list.intend_to_text"   />
                    </van-cell-group>
                </div>
            </div>
            <!-- 课程项目结束了，你觉得自己当前职业状态如何，综合成就感、价值感、幸福感等因素考虑？  -->
            <div  class="style_tags survey-mt">
                <h2>{{title_list[20]}}</h2>
                <van-cell-group class="style_tags grouping">
                    <van-field placeholder="请选择你对自己分享项目的意愿度分数"  v-model="survey_list.factors"  @click="pickerType('factors')" readonly />
                    <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
                </van-cell-group>
            </div>
            <!-- 完成课程项目后，你对未来2-3年的职业发展路径的清晰程度打几分？  -->
            <div  class="style_tags survey-mt">
                <h2>{{title_list[21]}}</h2>
                <van-cell-group class="style_tags grouping">
                    <van-field placeholder="请选择你对未来2-3年的职业发展路径的分数？"  v-model="survey_list.develop_clarity"  @click="pickerType('develop_clarity')" readonly />
                    <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
                </van-cell-group>
            </div>
            <!-- 你对自己近期的转型or工作提升计划清晰程度如何？  -->
            <div  class="style_tags survey-mt">
                <h2>{{title_list[22]}}</h2>
                <van-cell-group class="style_tags grouping">
                    <van-field placeholder="请选择你对自己近期的转型or工作提升计划清晰程度分数？"  v-model="survey_list.work_plan"  @click="pickerType('work_plan')" readonly />
                    <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
                </van-cell-group>
            </div>
            <!-- 你当前的信息搜索能力如何？  -->
            <div  class="style_tags survey-mt">
                <h2>{{title_list[23]}}</h2>
                <van-cell-group class="style_tags grouping">
                    <van-field placeholder="请选择你当前的信息搜索能力分数"  v-model="survey_list.search_ability"  @click="pickerType('search_ability')" readonly />
                    <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
                </van-cell-group>
            </div>
            <!-- 你当前和别人协同合作的能力如何？  -->
            <div  class="style_tags survey-mt">
                <h2>{{title_list[24]}}</h2>
                <van-cell-group class="style_tags grouping">
                    <van-field placeholder="请选择你当前和别人协同合作的能力分数"  v-model="survey_list.cooperative_ability"  @click="pickerType('cooperative_ability')" readonly />
                    <label class="choose_lable" :style="{'background-position-y': arrow ? 'bottom' : 'top'}"></label>
                </van-cell-group>
            </div>
            <!--  -->
            <!-- -------修改--------- -->
            <!-- 对你完成项目最有帮助的环节是 -->
            <div class="style_tags survey-mt">
                <h2>{{title_list[25]}}</h2>
                <div class="style_tags_box clearfix">
                    <van-checkbox-group v-model="survey_list.interest">
                        <van-checkbox :class="{'last-checkbox':interest_group.length-1==index}"  v-for="(item,index) in interest_group" :key="index"   :name="item"><div class="interest">{{item}}</div></van-checkbox>
                    </van-checkbox-group>
                </div>
            </div>
            <!--  -->
            <!-- -------修改--------- -->
            <!-- 【你对这种服务感兴趣吗】我有一些个人职业发展问题需要个性化解决，希望了解1对1咨询服务-->
            <!-- <div class="style_tags survey-mt">
                <h2>{{title_list[25]}}</h2>
                <div class="style_tags_box radio-box clearfix">
                    <van-radio-group v-model="survey_list.career_issues">
                        <van-radio   v-for="(item,index) in career_issues_group" :key="index" :name="item">{{item}}</van-radio>
                    </van-radio-group>
                </div>
            </div> -->
            <!-- 【你对这种服务感兴趣吗】通过系统的专业系列课程培训，成为执业生涯规划师或以此为第二职业，支持更多人发展？-->
            <!-- <div class="style_tags survey-mt">
                <h2>{{title_list[26]}}</h2>
                <div class="style_tags_box radio-box clearfix">
                    <van-radio-group v-model="survey_list.training_course">
                        <van-radio   v-for="(item,index) in career_issues_group" :key="index" :name="item">{{item}}</van-radio>
                    </van-radio-group>
                </div>
            </div> -->

            <!-- 提交 -->
            <div  class="submit">
                <van-button :class="['btn',validation?'on':'']" @click="submitHandle" type="default">提交并生成证书</van-button>
            </div>
        </div>
        <van-popup v-model="picker_show" position="bottom">
            <!-- 项目整体体验满意度 -->
            <van-picker v-if='picker_show' :default-index='pop_index' show-toolbar :columns="satisfied_group"    @cancel="picker_show=false" @confirm="confirm" />

        </van-popup>
    </div>
</template>

<script>
import { shareCon } from "@/utils/wxconfig";
import { getStorage, setStorage } from "@/utils/tools"
import { courseSurvey,getCourseSurvey } from "@/api/course";
export default {
    data() {
        return{
            body_show:false,
            // 
            arrow:false,
            picker_show:false,
            picker_type:0,
            pop_index:0,
            // 下边对象内属和标题一一对应
            survey_list:{
                consistent:'',
                experience:'',
                input:'',
                course_content:'',
                project_tasks:'',
                operating:'',
                harvest:'',
                no_harvest:'',
                help_link:[],
                no_help_link:[],
                problem:[],
                project_harvest:'',
                advice:'',
                ta:'',
                ta_advice:'',
                introduce:'',
                introduce_successful:'',
                introduce_failure:'',
                intend_to:'',
                intend_to_text:'',
                factors:'',
                develop_clarity:'',
                work_plan:'',
                search_ability:'',
                cooperative_ability:'',
                interest:[]
                // career_issues:'',
                // training_course:'',
            },
            title_list:[
                '课程的整体体验，和你预期的相符程度？',
                '你对项目整体体验的满意度？',
                '给自己在项目过程中的【投入度】打个分',
                '你对【课程内容】的满意程度 ',
                '你对【项目任务】设置的整体满意程度',
                '你对【运营支持】的整体满意程度',
                '你觉得最有收获的项目是？',
                '你觉得收获不大的项目是？',
                '对你完成项目最有帮助的环节是',
                '对你完成项目帮助不大的环节是',
                '学习过程中，你遇到的问题是？',
                '你在本次项目学习中最重要的三点收获？',
                '你对项目还有哪些意见与建议？希望如何改进？',
                '在项目过程中，你对【助教】提供支持的满意程度',
                '你对你的助教有什么想说的？建议、意见或者纯表白',
                '整体项目期间，你有没有给身边人介绍个人战略课？',
                '如果有，你是如何介绍这个项目的？',
                '如果没有，原因是什么？',
                '请将你对自己分享项目的意愿度打分：',
                '为什么愿意分享？or为什么不愿意分享？',
                '课程项目结束了，你觉得自己当前职业状态如何，综合成就感、价值感、幸福感等因素考虑？',
                '完成课程项目后，你对未来2-3年的职业发展路径的清晰程度打几分？',
                '你对自己近期的转型or工作提升计划清晰程度如何？',
                '你当前的信息搜索能力如何？',
                '你当前和别人协同合作的能力如何？',
                '【你对这种服务感兴趣吗】'
                // '【你对这种服务感兴趣吗】我有一些个人职业发展问题需要个性化解决，希望了解1对1咨询服务',
                // '【你对这种服务感兴趣吗】通过系统的专业系列课程培训，成为执业生涯规划师或以此为第二职业，支持更多人发展？'
            ],
            consistent_name:'',
            help_link_name:'',
            no_help_link_name:'',
            problem_name:'',
            introduce_name:'',
            // 相符度
            consistent_group:['超出期待','基本相符','不符合期待','其他'],
            // 满意度
            satisfied_group:['10','9','8','7','6','5','4','3','2','1','0'],
            // 收获
            harvest_group:['P0项目导入','P1行业调研','P2对标人物','P3职业目标','P4发展路书'],
            // 没有收获
            no_harvest_group:['P0项目导入','P1职业赛道调研报告','P2对标人物研究报告','P3个人职业目标报告','P4个人发展路书报告'],
            // 
            help_link_group:['项目攻略和工具箱','小组线上讨论','项目公开路演','助教的任务点评','每日一问','教练项目辅导','其他'],
            // 
            problem_group:['时间不够用','目标不清晰','学完不知道怎么落地','资料看不完','小组不给力','助教不支持','其他'],
            // 
            introduce_group:['有','没有','有想法，但不知如何介绍','其他'],
            interest_group:['一对一职业咨询，我有一些个人职业发展问题需要个性化解决','生涯规划师系列培训，我期待通过系统的专业系列课程培训，成为执业生涯规划师或以此为第二职业，支持更多人发展','没兴趣']
            // career_issues_group:['感兴趣','不感兴趣','暂不需要'],
            // 
        }
    },
    computed:{
        // 验证
        validation(){
            let str_fields = [
                'experience',
                'input',
                'course_content',
                'project_tasks',
                'operating',
                'harvest',
                'project_harvest',
                'advice',
                'ta',
                'ta_advice',
                'introduce',
                'no_harvest',
                'intend_to',
                'intend_to_text',
                'factors',
                'develop_clarity',
                'work_plan',
                'search_ability',
                'cooperative_ability',
                // 'career_issues',
                // 'training_course'
            ];
            let radio_fields = [
                'consistent',
                'introduce'
            ];
            let num_fields = [
                'help_link',
                'no_help_link',
                'problem',
                'interest'
            ];
            // 循环判断数组内属性内容是为空
            for(let i = 0; i < str_fields.length; i++) {
                if(this.$Validator.isEmpty(String(this.survey_list[str_fields[i]]))){
                    return false;
                }
                if(this.$Validator.isEmpty(this.survey_list['introduce_successful']) && this.survey_list['introduce']==='有'){
                    return false;
                }
                if(this.$Validator.isEmpty(this.survey_list['introduce_failure']) && this.survey_list['introduce']==='没有'){
                    return false;
                }
            }
            for(let i = 0; i < radio_fields.length; i++) {
                if((this.survey_list[radio_fields[i]].indexOf('其他')>-1 && !this[radio_fields[i]+'_name'])){
                    return false;
                }
            }
            for(let i = 0; i < num_fields.length; i++) {
                //  
                if(this.survey_list[num_fields[i]] <=0 || this.survey_list[num_fields[i]] ==''|| (this.survey_list[num_fields[i]].indexOf('其他')>-1 && !this[num_fields[i]+'_name'])){
                    return false;
                }
            }
            return true;
        }
    },
    methods:{
        // 弹出选择框  存储选择的值
        // 1 项目整体体验满意度、2、你对【课程内容】的满意程度3、你对【项目任务】设置的整体满意程度4、你对【运营支持】的整体满意程度
        // 5、你对【助教】提供支持的满意程度、6、请将你对自己分享项目的意愿度打分、7、因素、8、清晰度
        confirm(data){
            this.survey_list[this.picker_type] = data;
            this.picker_show=false;
            // 重置选择框值
            this.pop_index = 0;
        },
        // 显示选择框
        pickerType(type){
            this.picker_type=type;
            this.picker_show=true;
        },
        // 处理其它
        otherHandle(){
            let str_fields = [
                'help_link',
                'no_help_link',
                'problem',
                'consistent',
                'introduce'
            ];
            // 循环处理数据
            for(let i = 0; i < str_fields.length; i++) {
                let field = this.survey_list[str_fields[i]];
                if(typeof field == 'string') {
                    if (field == '其他') {
                        this.survey_list[str_fields[i]] = '其他/'+this[str_fields[i]+'_name'];
                    }
                } else {
                    if(field.indexOf('其他')>-1){
                        field[field.indexOf('其他')] = '其他/'+this[str_fields[i]+'_name'];
                    }
                }
            }
        },
        // 提交数据
        submitHandle(){
            if(!this.validation){
                this.$toast('请检查数据是否为空哦！');
                return
            }
            this.otherHandle();

            let arr = [];
            // 获得对象的长度
            for(let i=0;i<Object.keys(this.survey_list).length;i++){
                arr.push({
                    title:this.title_list[i],
                    // 获得对应key下边的值
                    content:this.survey_list[Object.keys(this.survey_list)[i]],
                    type:Object.keys(this.survey_list)[i]
                });
            }
            courseSurvey({
                cid:this.$route.query.cid,
                text:JSON.stringify(arr)
            }).then((data)=>{
                if (data.code && data.code === 10002) {
                    this.$toast(data.data.msg);
                    return;
                }
                this.$toast({
                    message: '提交成功!',
                    duration:1000,
                    onClose:()=>{
                        this.$router.push({
                            path:'/certificate'
                        });
                    }
                });
            }).catch((err)=>{
                this.$dialog.alert({
                    message:'保存失败，服务器出错！请稍后重试！'
                });
            });
        },
        // 截取判断是否有其他
        isOther(val,name){
            let list = '', arr;
            // 判断是否是数组
            if(val instanceof Array){
                let index,Arr;
                for(let key in val){
                    // 判断是否有'其他'
                    if(val[key].indexOf('其他')>-1){
                        Arr = val[key].split('/');
                        index = key;
                        this[name+'_name'] = Arr[1];
                        this.$set(val,index,'其他');
                    };
                }
                arr = val;
                
            }else{
                if(val.indexOf('其他')>-1){
                    list = val;
                    arr = list.split('/');
                    this[name+'_name'] = arr[1];
                    arr = '其他';
                }else{
                    arr = val;
                }
                
            }

            return arr;
        },
        pullData(){
            this.$toast.loading({
                mask: true,
                message: "加载中..."
            });
            getCourseSurvey({
                cid:this.$route.query.cid
            }).then((data)=>{
                if(data.code && data.code ===10002){
                    this.$toast(data.msg);
                    return
                }
                // 判断是否已经存在数据
                if(data.info){
                    let list = JSON.parse(data.info.text);
                    for(let i= 0;i<list.length;i++){
                        if(
                            list[i].type === 'no_help_link' 
                            || list[i].type ===  'help_link' 
                            || list[i].type ===  'problem' 
                            || list[i].type ===  'consistent'
                            || list[i].type ===  'introduce'
                        ){
                            this.survey_list[list[i].type] = this.isOther(list[i].content,list[i].type)
                        }else{
                            this.survey_list[list[i].type] = list[i].content;
                        }
                    }
                }else{
                    let path =this.$route.path;

                    this.survey_list = getStorage(path,'survey_list') || this.survey_list;

                    this['consistent_name'] = getStorage(path, 'consistent_name') || '';
                    this['help_link_name'] = getStorage(path, 'help_link_name') || '';
                    this['no_help_link_name'] = getStorage(path, 'no_help_link_name') || '';
                    this['problem_name'] = getStorage(path, 'problem_name') || '';
                    this['introduce_name'] = getStorage(path, 'introduce_name') || '';
                }
                

                this.body_show = true;
                this.$toast.clear();
            });
        }
    },
    created(){
        this.pullData();
        shareCon("survey", this);
    },
    watch:{
        survey_list:{
            handler(newVal, oldVal) {
                setStorage(this.$route.path, 'survey_list', newVal);
    　　　　},
    　　　　deep: true
        },
        consistent_name(newVal,oldVal){
            setStorage(this.$route.path, 'consistent_name', newVal);
        },
        help_link_name(newVal,oldVal){
            setStorage(this.$route.path, 'help_link_name', newVal);
        },
        no_help_link_name(newVal,oldVal){
            setStorage(this.$route.path, 'no_help_link_name', newVal);
        },
        problem_name(newVal,oldVal){
            setStorage(this.$route.path, 'problem_name', newVal);
        },
        introduce_name(newVal,oldVal){
            setStorage(this.$route.path, 'introduce_name', newVal);
        },
    }
}
</script>

<style lang="scss" scoped>
.interest{
    width:600px;
    line-height:42px;
}
.survey-main{
    padding: 30px 0 80px;
    h2.title{
        margin-bottom: 60px;
        font-size:32px;
        color: #EB5032;
    }
}
.style_tags{
    color: #333;
    h2{
        margin-bottom: 30px;
        font-size: 32px;
        text-align: left;
        line-height: 42px;
        font-weight: normal;
        span{
            font-size: 26px;
            color: #999;
        }
    }
    .survey-other{
        display: inline-block;
        width: auto;
        line-height: 70px;
        padding: 0 0 0 8px;
        border:2px solid rgba(204,204,204,1);
        border-radius:8px;
        width: 544px;
    }
}
.submit{
    margin-top: 80px;
    text-align: center;
    .btn{
        width:578px;
        line-height:80px;background-color: #CCCCCC;
        border-radius:8px;
        color: #fff;
        font-size:34px;
    }
    .btn.on{
        background:#EB5032;
    }
}
.survey-mt{
    margin-top: 30px;
}
</style>
<style lang="scss">
// 风格标签
.style_tags .van-checkbox-group,.style_tags  .radio-box .van-radio-group{
    .van-checkbox,.van-radio{
        font-size: 26px;
        margin-bottom: 20px;
        line-height:34px;
    }
    .van-checkbox.last-checkbox,.van-radio.last-checkbox{
        display: inline-block;
        line-height: 70px;
        margin-bottom: 0;
    }
    .van-checkbox .van-checkbox__label,.van-radio .van-radio__label{
        position: relative;
        line-height: 1;
    }
    .van-checkbox .van-checkbox__icon,.van-radio .van-radio__icon{
        height: 34px;
        line-height:34px;
    }
    .van-checkbox .van-checkbox__icon .van-icon,.van-radio .van-radio__icon .van-icon{
        width:34px;
        height: 34px;
        border:0;
        border-radius: 0;
        border-color: transparent;
        background-color: transparent;
        background-image: url(../../../assets/normal.png);
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }
    .van-checkbox__icon.van-checkbox__icon--checked .van-icon.van-icon-success{
        background-image: url(../../../assets/press.png);
    }
    .van-radio .van-radio__icon .van-icon{
        background-image: url(../../../assets/radio_.png);
    }
    .van-radio__icon.van-radio__icon--checked .van-icon.van-icon-success{
        background-image: url(../../../assets/radio_active.png);
    }
    .van-checkbox .van-checkbox__icon .van-icon:before,.van-radio .van-radio__icon .van-icon:before{
        content:'';
    }
}
.style_tags  .radio-box .van-radio-group{
    
    
    .van-radio .van-radio__icon .van-icon:before{
        content:'';
    }
}
.style_tags .textarea .van-field__control{
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 8px;
    padding: 8px;
}

</style>
